import React from "react";
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";
import {Collections, Types} from "components/index";

import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

import moment from "moment";
import {Link} from 'react-router-dom';
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import TextField from "@material-ui/core/TextField";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import UserRoles from "../../constants/UserRoles";
import {isEmptyObject} from "jquery";
import {freshdeskTicketDisplay, freshdeskTicketUrl, isPendingFreshdeskTicket} from "utils/freshdeskTicket";
import {isFeBookableOnDate} from "../../constants/feBookable";


/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */
class ScheduleTicket extends Framework.Components.Object {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		provideLocation: PropTypes.func,
	};

	constructor(props) {
		super(props, Types.Tickets._name);
		this.redirect = this.props.baseUrl;
		this.state.urls = [];
		this.state.filterMostRecent = true;
		this.state.filterInRegion = true;
		this.state.TFOModal = false;
		this.state.tab = 'TFOs';
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot)
		if (this.compareScheduleInfo(prevProps) === true && this.props.scheduleInfo !== undefined) {
			this.setState({
				appointment_start: this.props.scheduleInfo.start,
				appointment_end: this.props.scheduleInfo.end
			})
			if (typeof this.props.scheduleInfo.fe === "string" && this.props.scheduleInfo.fe !== prevProps.field_engineers) {
				this.setState({field_engineers: this.props.scheduleInfo.fe})
			} else {
				console.log("Something went wrong.")
			}
		}

		if (this.props.mapsUrls && (prevProps.mapsUrls !== this.props.mapsUrls)) {
			this.setState({urls: this.props.mapsUrls})
		}

		if (prevState.appointment_start !== this.state.appointment_start) {
			this.clearFieldEngineerIfUnbookable(this.state.appointment_start);
		}
	}

	appointmentCalendarDay = (value) => {
		if (!value) return "";
		const parsed = moment(value);
		return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
	};

	clearFieldEngineerIfUnbookable = (appointmentStart) => {
		if (!this.state.field_engineer) return;
		const fe = this.state.field_engineers;
		if (!fe || typeof fe !== "object") return;
		if (isFeBookableOnDate(fe, appointmentStart)) return;
		this.handleSelectPropertyUpdate("field_engineer", "", "field_engineers", null);
	};

	handleTabChange = (event, newValue) => {
		this.props.history.push('#' + newValue);
		this.setState({tab: newValue});
	};

	handleDelete = async () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to delete this? (NOTE: Will not delete ticket but make ticket appointment times blank)',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						if (this.props.eventID) {
							let modelCal = new API.BuildClass(Types.Calendar._name, API.RequestType.DELETE);
							this.delete = 'DELETE';
							modelCal.object.pkey = this.props.eventID;
							try {
								await modelCal.submit(null, this.delete);
								//put this update data in the afterDelete?
								this.props.updateData();
							} catch (error) {
							}
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});

		this.toggleClose();
	}

	compareScheduleInfo = (prevProps) => {

		let oldInfo = prevProps.scheduleInfo;
		let newInfo = this.props.scheduleInfo;
		return (newInfo?.ticket === this.state.pkey) && (((oldInfo?.start !== newInfo?.start) || (oldInfo?.end !== newInfo?.end)) || (oldInfo?.fe !== newInfo?.fe));
	}
	// redirect = "/tickets/[ID]/schedule";

	// noinspection JSUnusedGlobalSymbols
	/** @param {Tickets_Object} object */
	loadSelfAfter(object) {
		if (typeof this.props.updateFilter === 'function') {
			this.props.updateFilter(this.state.field_engineer);
		}
		if (typeof this.props.updateTime === 'function') {
			this.props.updateTime(this.state.appointment_start);
		}
		let {customers, customers_locations, field_engineer} = this.state;

		if (typeof this.props.provideLocation === 'function') {
			let name = customers.name;
			let address = customers_locations.street_1 + " " + customers_locations.city + ", " + customers_locations.state + " " + customers_locations.zip;

			this.props.provideLocation(name, address, field_engineer);
		}
	};


	toggleClose = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	setDefaultFilters = () => {
		let requests = JSON.parse(localStorage.getItem('table-preferences-Reschedules'));
		if (isEmptyObject(requests)) {
			requests = {default: {startDate: null, endDate: null}}
		}
		requests.default.limit = 10;
		localStorage.setItem('table-preferences-Reschedules', JSON.stringify(requests));
	}

	cancelSameDayTicket = async () => {
		confirmAlert({
			title: 'Confirm Same Day Cancel',
			message: 'Are you sure you want to flag this as a Same Day Cancel? This CANNOT be removed, if it needs to be changed a new ticket will have to be made.',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						await this.setState({same_day_cancel: !this.state.same_day_cancel});
						let modelCal = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
						this.state.id = this.state.pkey;
						await modelCal.submit(this, 'POST_TICKET_CANCEL', true);
						await this.loadSelf();
						this.setDefaultFilters();

						this.setState({TFOModal: true, isLoading: true})
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});



	}

	cancelTicket = async () => {
		await this.setState({cancelled: !this.state.cancelled});
		let modelCal = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
		this.state.id = this.state.pkey;
		await modelCal.submit(this, 'POST_TICKET_CANCEL', true);
		await this.loadSelf();
		this.props.suspendTimeout();
		this.setDefaultFilters();

		this.setState({TFOModal: true, isLoading: true})
	}

	remoteWorkTicket = async () => {
		await this.setState({remote_work: !this.state.remote_work});
		let modelCal = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
		modelCal.object.id = this.props.id;
		modelCal.object.remote_work = this.state.remote_work;
		await modelCal.submit(null, 'POST_TICKET_REMOTE', true);
		await this.loadSelf();
		this.props.suspendTimeout();

		this.setState({isLoading: true})
	}

	rescheduleTicket = async () => {
		await this.setState({rescheduled: !this.state.rescheduled});
		let modelCal = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
		modelCal.object.id = this.props.id;
		modelCal.object.rescheduled = this.state.rescheduled;
		await modelCal.submit(null, 'POST_TICKET_RESCHEDULE', true);
		await this.loadSelf();
		this.props.suspendTimeout();
		this.setDefaultFilters();

		this.setState({TFOModal: true, isLoading: true})
	}

	prefersSooner = async () => {
		await this.setState({prefers_sooner: !this.state.prefers_sooner});
		let modelCal = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
		modelCal.object.id = this.props.id;
		modelCal.object.prefers_sooner = this.state.prefers_sooner;
		await modelCal.submit(null, 'POST_TICKET_SOONER', true);
		await this.loadSelf();
		this.props.suspendTimeout();
		this.setDefaultFilters();
	}


	render() {
		let {properties} = this.model;
		let {
			loading,
			loaded,
			field_engineers,
			fresh_ticket,
			appointment_start,
			appointment_end,
		} = this.state;
		let object = this.state;

		if (!loaded) {
			return (
				<Framework.Elements.LoadingSpinner isLoading={true}/>
			)
		}

		let fresh_engineer = field_engineers.name_first?.trim() + "." + field_engineers.name_last?.trim();

		let freshdeskPending = isPendingFreshdeskTicket(fresh_ticket);
		let link1 = freshdeskTicketUrl(fresh_ticket);
		let freshdeskLabel = freshdeskTicketDisplay(fresh_ticket);
		let link2 = 'https://www.karlstechnology.com/ktma/dash.php?ticket=' + fresh_ticket + '&user=' + fresh_engineer

		let creatorName = this.state.users_related_by_creator.name_first + " " + this.state.users_related_by_creator.name_last + " " + "(" +
			this.state.users_related_by_creator.email + ")";
		let cancelledName = this.state.cancelled_user ? this.state.cancelled_users?.name_first + " " + this.state.cancelled_users?.name_last + " " + "(" +
			this.state.cancelled_users?.email + ")" : 'Admin (admin@karlstechnology.com)';
		let rescheduledName = this.state.rescheduled_user ? this.state.rescheduled_users?.name_first + " " + this.state.rescheduled_users?.name_last + " " + "(" +
			this.state.rescheduled_users?.email + ")" : 'Admin (admin@karlstechnology.com)';
		let prefersSoonerName = this.state.prefers_sooner_user ? this.state.prefers_sooner_user?.name_first + " " + this.state.prefers_sooner_user?.name_last + " " + "(" +
			this.state.prefers_sooner_user?.email + ")" : 'Admin (admin@karlstechnology.com)';
		return (
			<div>
				<fieldset>
					{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) &&
						<div className={"section-title"}>
							<h4 className="section-title">Ticket Entry #{this.props.id}</h4>
							<div className={"flex-end text-right"}>
								<Link to={`/tickets/${this.props.id}`} target={'_blank'} className={'px-1'}>
									<Button color="info">
										<i className={"fa fa-ticket"}/> Go To Ticket
									</Button>
								</Link>
								{this.state.new_existing &&
									<Link to={`/customers/${this.state.customer}#tickets`} target={'_blank'} className={'px-1'}>
										<Button color="info">
											<i className={"fa fa-ticket"}/> Go To Customer's Tickets
										</Button>
									</Link>
								}
								<Link to={`/customers/${this.state.customer}`} target={'_blank'} className={'px-1'}>
									<Button color="primary">
										<i className={"fa fa-ticket"}/> Go To Customer
									</Button>
								</Link>
							</div>
						</div>
					}
					<div className={"row"}>

						<div className={"col-lg-4 col-sm-12"}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Customer"}
									value={this.state.ticket_customer}
									error={this.state.ticket_customer_error}
									property={properties.ticket_customer}
									update={this.handleTextFieldPropertyUpdate}
									disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
								/>
							</div>
						</div>


						<div className={"col-lg-4 col-sm-12"}>
							<div className="form-group">
								{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) ?
									<Framework.Elements.TextField
										label={"Location"}
										value={this.state.ticket_location}
										error={this.state.ticket_location_error}
										property={properties.ticket_location}
										update={this.handleTextFieldPropertyUpdate}
										disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
									/> :
									<a target={"_blank"}
									   href={`https://www.google.com/maps/dir/${this.state.ticket_location.replaceAll(' ', '+').replaceAll('#', '%23')}`}>
										<Framework.Elements.TextField
											label={"Location"}
											value={this.state.ticket_location}
											error={this.state.ticket_location_error}
											property={properties.ticket_location}
											update={this.handleTextFieldPropertyUpdate}
											disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
										/>
									</a>}
							</div>
						</div>


						<div className={"col-lg-4 col-sm-12"}>
							<div className="form-group">
								{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) ?
									<Framework.Elements.TextField
										label={"Map Address Override"}
										value={this.state.location_override}
										error={this.state.location_override_error}
										property={properties.location_override}
										update={this.handleTextFieldPropertyUpdate}
										disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
									/> :
									<a target={"_blank"}
									   href={this.state.location_override ?
										   `https://www.google.com/maps/dir/${this.state.location_override.replaceAll(' ', '+').replaceAll('#', '%23')}` :
										   null}>
										<Framework.Elements.TextField
											label={"Map Address Override"}
											value={this.state.location_override}
											error={this.state.location_override_error}
											property={properties.location_override}
											update={this.handleTextFieldPropertyUpdate}
											disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
										/>
									</a>}
							</div>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-lg-2 col-sm-6"} style={{paddingLeft: 15, paddingRight: 5}}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"New/Existing"}
									value={this.state.new_existing ? "*Existing*" : "*New*"}
									error={this.state.new_existing_error}
									property={properties.new_existing}
									update={this.handleTextFieldPropertyUpdate}
									disabled={true}
								/>
							</div>
						</div>

						<div className={"col-lg-2 col-sm-6"} style={{paddingLeft: 5, paddingRight: 5}}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Summary"}
									value={this.state.summary}
									error={this.state.summary_error}
									property={properties.summary}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<div className={'col-lg-2 col-sm-6'} style={{paddingLeft: 5, paddingRight: 5}}>
							<div className={'form-group'}>
								{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) ?
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="phone"
										label="Primary"
										value={this.state.customers.phone}
										disabled={true}
									/> :
									<a target={"_blank"} href={`tel:${this.state.customers.phone}`}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="phone"
											label="Primary"
											value={this.state.customers.phone}
											disabled={true}
										/>
									</a>
								}
							</div>
						</div>
						{this.state.customers.phone_alt && <div className={'col-lg-2 col-sm-6'} style={{paddingLeft: 5, paddingRight: 5}}>
							<div className={'form-group'}>
								{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) ?
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="phone_alt"
										label="Alternate"
										value={this.state.customers.phone_alt}
										disabled={true}
									/> :
									<a target={"_blank"} href={`tel:${this.state.customers.phone_alt}`}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="phone_alt"
											label="Alternate"
											value={this.state.customers.phone_alt}
											disabled={true}
										/>
									</a>}
							</div>
						</div>}
						<div className={'col-lg-4 col-sm-12'} style={{paddingLeft: 5, paddingRight: 15}}>
							<div className={'form-group'}>
								{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) ?
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="email"
										label="Email"
										value={this.state.customers.email}
										disabled={true}
									/> :
									<a target={"_blank"} href={`mailto: ${this.state.customers.email}`}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="email"
											label="Email"
											value={this.state.customers.email}
											disabled={true}
										/>
									</a>}
							</div>
						</div>
					</div>

					<div className={'row'}>
						<div className={'col-12'}>
							<div className="form-group">
								<TextField
									fullWidth
									margin="dense"
									variant="outlined"
									name="cust_notes"
									label="Client Notes"
									value={this.state.customers.notes ? this.state.customers.notes : "This customer has no booking notes, please go to customer to add."}
									disabled={true}
									multiline
									rows={2}
								/>
							</div>
						</div>
					</div>

					<div className={'row'}>
						<div className={'col-12'}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Description"}
									value={this.state.description}
									error={this.state.description_error}
									property={properties.description}
									update={this.handleTextFieldPropertyUpdate}
									multiline
									rows={6}
								/>
							</div>
						</div>
					</div>

					<div className={'row'}>
						<div className={'col-12'}>
							<div className="form-group">
								{freshdeskPending ? (
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="freshdesk"
										label="Freshdesk Link"
										value={freshdeskLabel}
										disabled={true}
									/>
								) : (
									<a href={link1} target={"_blank"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="freshdesk"
											label="Freshdesk Link"
											value={link1}
											disabled={true}
										/>
									</a>
								)}
							</div>
						</div>
						{this.props.rootState.main_role !== 40 && <div className={'col-12'}>
							<div className="form-group">
								<a href={link2} target={"_blank"}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="kt3ticket"
										label="KT2 Ticket Link"
										value={link2}
										disabled={true}
									/>
								</a>
							</div>
						</div>}
					</div>

					<div className={"row"}>
						<div className={"col"} style={{fontSize: 16}}>

						</div>
					</div>

					<div className="form-group" style={window.innerWidth >= 760 ? {marginBottom: '-20px'} : null}>
						<div className={"row"}>
							<div className={"col"}>
								{freshdeskPending ? (
									<Button size={'md'} color={'secondary'} disabled={true}>
										Freshdesk Pending
									</Button>
								) : (
									<a href={link1} target={"_blank"}>
										<Button size={'md'} color={'primary'}>
											Freshdesk
										</Button>
									</a>
								)}
							</div>

							{this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role)) && <>
								<div className={'col'}>
									<div className="form-group">
										<div className={"form-group"} style={{textAlign: 'center'}}>
											<Framework.Elements.Checkbox
												key={object.same_day_cancel}
												value={object.same_day_cancel}
												disabled={object.same_day_cancel}
												property={properties.same_day_cancel}
												error={object.same_day_cancel_error}
												update={this.cancelSameDayTicket}
												color="primary"
												label={'Same Day Cancel'}
											/>
										</div>
									</div>
								</div>
								<div className={'col'}>
									<div className="form-group">
										<div className={"form-group"} style={{textAlign: 'center'}}>
											<Framework.Elements.Checkbox
												value={object.cancelled}
												property={properties.cancelled}
												error={object.cancelled_error}
												update={this.cancelTicket}
												color="primary"
												label={'Cancelled'}
											/>
										</div>
									</div>
								</div>
								<div className={'col'}>
									<div className="form-group">
										<div className={"form-group"} style={{textAlign: 'center'}}>
											<Framework.Elements.Checkbox
												value={object.remote_work}
												property={properties.remote_work}
												error={object.remote_work_error}
												update={this.remoteWorkTicket}
												color="primary"
												label={'Remote Work'}
											/>
										</div>
									</div>
								</div>
								<div className={'col'}>
									<div className="form-group">
										<div className={"form-group"} style={{textAlign: 'center'}}>
											<Framework.Elements.Checkbox
												value={object.rescheduled}
												property={properties.rescheduled}
												error={object.rescheduled_error}
												update={this.rescheduleTicket}
												color="primary"
												label={'Needs Rescheduled'}
											/>
										</div>
									</div>
								</div>
								<div className={'col'}>
									<div className="form-group">
										<div className={"form-group"} style={{textAlign: 'center'}}>
											<Framework.Elements.Checkbox
												value={object.prefers_sooner}
												property={properties.prefers_sooner}
												error={object.prefers_sooner_error}
												update={this.prefersSooner}
												color="primary"
												label={'Prefers Sooner'}
											/>
										</div>
									</div>
								</div>
							</>}
							{this.props.rootState.main_role !== 40 && <div className={"col flex-end text-right"}>
								<a href={link2} target={"_blank"}>
									<Button size={'md'} color={'primary'}>
										KT2 Ticket
									</Button>
								</a>
							</div>}
						</div>
					</div>


					<h4 className="section-title">Scheduled Appointment</h4>

					<div className={'row'}>
						<div className={'col-lg-6 col-sm-12'}>
							<div className="form-group">
								<Framework.Elements.DateTime
									label={"Start Time"}
									property={properties.appointment_start}
									value={appointment_start}
									update={this.handleTextFieldPropertyUpdate}
									defaultTimezone={"America/Phoenix"}
									disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
								/>
							</div>
						</div>
						<div className={'col-lg-6 col-sm-12'}>
							<div className="form-group">
								<Framework.Elements.DateTime
									label={"End Time"}
									property={properties.appointment_end}
									value={appointment_end}
									update={this.handleTextFieldPropertyUpdate}
									defaultTimezone={"America/Phoenix"}
									disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
								/>
							</div>
						</div>
					</div>
					<div className={'row'}>
						<div className={'col-12'}>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									property={properties.field_engineer}
									value={object.field_engineer}
									error={object.field_engineer_error}
									object={object.field_engineers}
									update={this.handleSelectPropertyUpdate}
									groupBy={(option) =>
										option.original.region
											? option.original.regions?.name
											: "No Region"
									}
									requestOverride={"GET_FIELD_ENGINEERS"}
									filter={(user) => isFeBookableOnDate(user, appointment_start)}
									objectKey={`${this.props.location ?? ""}|${this.appointmentCalendarDay(appointment_start)}`}
									defaultGroup={this.props.location}
									limit={null}
									sort={"ranking"}
									text={"name_first&name_last"}
									showToolTip={true}
									default={""}
									groupSort={(option) => option.original?.regions ? option.original.regions.ranking : 100}
									disabled={!this.props.rootState.roles.some(role => [10, 20, 25, 30].includes(role))}
								/>
							</div>
						</div>
					</div>
					<div className={'row'}>
						<div className={'col-lg-8 col-sm-12'}>
							<Button data-id="calendar-log"
							        onClick={this.toggle('modalCalendarLog')}
							        size="sm"
							        color="grey">
								<i className="fa fa-user"/>&nbsp;&nbsp;Created By {creatorName} on&nbsp;
								{moment(object.created).format('MM/DD/YY')}
								&nbsp;at {moment(object.created).format('h:mm a')}
							</Button>
						</div>
						{(!object.cancelled && !object.same_day_cancel && !object.rescheduled) && <div className={"col flex-end text-right"}>
							Referred By: {this.state.customers.referer}
						</div>}
					</div>

					{(object.cancelled || object.same_day_cancel) &&
						<div className={'row'}>
							<div className={'col-lg-8 col-sm-12'}>
								<Button data-id="calendar-log"
								        onClick={this.toggle('modalCalendarLog')}
								        size="sm"
								        color="grey">
									<i className="fa fa-user"/>&nbsp;&nbsp;Cancelled By {cancelledName} on&nbsp;
									{moment(object.cancelled_timestamp).format('MM/DD/YY')}
									&nbsp;at {moment(object.cancelled_timestamp).format('h:mm a')}
								</Button>
							</div>
							{!object.rescheduled && <div className={"col flex-end text-right"}>
								Referred By: {this.state.customers.referer}
							</div>}
						</div>
					}

					{(object.rescheduled) &&
						<div className={'row'}>
							<div className={'col-lg-8 col-sm-12'}>
								<Button data-id="calendar-log"
								        onClick={this.toggle('modalCalendarLog')}
								        size="sm"
								        color="grey">
									<i className="fa fa-user"/>&nbsp;&nbsp;Flagged for Reschedule By {rescheduledName} on&nbsp;
									{moment(object.rescheduled_timestamp).format('MM/DD/YY')}
									&nbsp;at {moment(object.rescheduled_timestamp).format('h:mm a')}
								</Button>
							</div>
							{!object.prefers_sooner && <div className={"col flex-end text-right"}>
								Referred By: {this.state.customers.referer}
							</div>}
						</div>
					}

					{(object.prefers_sooner) &&
						<div className={'row'}>
							<div className={'col-lg-8 col-sm-12'}>
								<Button data-id="calendar-log"
								        onClick={this.toggle('modalCalendarLog')}
								        size="sm"
								        color="grey">
									<i className="fa fa-user"/>&nbsp;&nbsp;Flagged for Prefers Sooner By {prefersSoonerName} on&nbsp;
									{moment(object.prefers_sooner_timestamp).format('MM/DD/YY')}
									&nbsp;at {moment(object.prefers_sooner_timestamp).format('h:mm a')}
								</Button>
							</div>
							<div className={"col flex-end text-right"}>
								Referred By: {this.state.customers.referer}
							</div>
						</div>
					}

				</fieldset>
				<Framework.Elements.UniversalModal
					parent={this.props.eventID}
					history={this.props.history}
					object={Collections.CalendarLogModal}
					title={"Change Logs"}
					toggle={this.state.modalCalendarLog}
					reportClose={() => this.toggleClose('modalCalendarLog')}
					hideGoTo={true}
					hasSubmit={false}
					size={'xl'}
				/>


				<Modal
					isOpen={this.state.TFOModal}
					toggle={() => this.toggleClose('TFOModal')}
					size={"xl"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						TFOs in the Last Three Days
					</ModalHeader>
					<ModalBody>
						<div className={'row'}>
							<div className={'col-4'}>
								<ButtonGroup size={"md"}>
									<Button
										onClick={() => {
											this.setState({filterInRegion: true})
										}}
										outline={this.state.filterInRegion === false}
										active={this.state.filterInRegion === true}
									>
										In Region
									</Button>
									<Button
										onClick={() => {
											this.setState({filterInRegion: false})
										}}
										outline={this.state.filterInRegion === true}
										active={this.state.filterInRegion === false}
									>
										All Regions
									</Button>
								</ButtonGroup>
							</div>
							<div className={'col-4'}>
								<ButtonGroup size={"md"}>
									<Button
										onClick={() => {
											this.setState({filterMostRecent: true})
										}}
										outline={this.state.filterMostRecent === false}
										active={this.state.filterMostRecent === true}
									>
										Recent First
									</Button>
									<Button
										onClick={() => {
											this.setState({filterMostRecent: false})
										}}
										outline={this.state.filterMostRecent === true}
										active={this.state.filterMostRecent === false}
									>
										Oldest First
									</Button>
								</ButtonGroup>
							</div>
						</div>
						<div className={'row'}>
							<div className={'col-12'}>
								<h4 style={{textAlign: 'center'}}>Please update notes if you call a customer!</h4>
							</div>
						</div>
						<Tabs
							value={this.state.tab}
							onChange={this.handleTabChange}
							component={'div'}>
							<Tab label="TFOs" value="TFOs"/>
							<Tab label="Reschedules" value="Reschedules"/>
							<Tab label="Prefers Sooner" value="Sooner"/>
						</Tabs>
						<div className={classNames({'hidden': this.state.tab !== 'TFOs'})}>
							<Collections.PhoneLogs
								key={this.state.filterInRegion + this.state.filterMostRecent}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								showCSV={false}
								filter={{
									'filterTFO': true,
									'filterByRecent': this.state.filterMostRecent,
									'filterRegion': this.state.filterInRegion ? this.state.field_engineers.region : 'remote',
								}}
								isModal={true}
							/>
						</div>
						<div className={classNames({'hidden': this.state.tab !== 'Reschedules'})}>
							<Collections.Reschedules
								key={this.state.filterInRegion + this.state.filterMostRecent}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								showCSV={false}
								filter={{
									'filterByRecent': this.state.filterMostRecent,
									'filterRegion': this.state.filterInRegion ? this.state.field_engineers.region : 'remote',
								}}

							/>
						</div>
						<div className={classNames({'hidden': this.state.tab !== 'Sooner'})}>
							<Collections.PrefersSooner
								key={this.state.filterInRegion + this.state.filterMostRecent}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								showCSV={false}
								filter={{
									'filterByRecent': this.state.filterMostRecent,
									'filterRegion': this.state.filterInRegion ? this.state.field_engineers.region : 'remote',
									'filterDate': this.props?.parent?.state?.selectedDay ?? moment().format("YYYY-MM-DD")
								}}

							/>
						</div>
					</ModalBody>

					<ModalFooter>
						<Button color="secondary" onClick={() => {
							this.setState({TFOModal: false})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(ScheduleTicket);
